import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrWhitespace, pathJoin } from '@asamco/utils';
import { Observable } from 'rxjs';
import { Application } from '../../../../interfaces/application.interface';
import { ApplicationService } from '../../../../services/application.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoPagingModule, DxoPagerModule, DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';
@Component({
    selector: 'al-applications',
    templateUrl: './applications.component.html',
    styleUrls: ['./applications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        DxDataGridModule,
        DxoPagingModule,
        DxoPagerModule,
        DxiColumnModule,
        DxiButtonModule,
        DxTemplateModule,
        AsyncPipe,
    ],
})
export class ApplicationsComponent implements OnInit {
	public imgUrl = '';
	public testImgUrl = '';
	public applications$: Observable<Application[]>;

	constructor(private router: Router, private applicationService: ApplicationService, private route: ActivatedRoute) {
		this.onEditApplication = this.onEditApplication.bind(this);
	}

	ngOnInit(): void {
		this.applications$ = this.applicationService.get();

		this.testImgUrl = ('D:/Git/Appshell/app-shell/apps/application-link/src/assets/img/application-logos/Autotask-PSA.png');

		this.imgUrl = pathJoin([window['deployUrl'],  '/assets/img/']);
	}

	onEditApplication($event): void {
		this.router.navigate(['application-link/application/', $event.row.data.id]);
	}

	public getUrl(subUrl: string): string {
		if (!isNullOrWhitespace(this.imgUrl) && !isNullOrWhitespace(subUrl)) {
			return pathJoin([this.imgUrl, subUrl]);
		}
		return '';
	}
}
